<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row>
        <v-col cols="12" v-if="switch1">
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="pageSize"
            :loading="loading"
            :footer-props="{ itemsPerPageText:'Page Size' }"
            class="elevation-1"
            widths="1500"
            no-data-text="No Data"
            loading-text="Processing"
            hide-default-footer
            multi-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <v-row class="pa-3 ma-3" align="center" justify="center">
                    <span style="color:#239e46;">Total {{items.length}} , Page Size</span>

                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn dark text color="#239e46" class="ml-2" v-on="on">
                          {{ itemsPerPage }}
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(number, index) in itemsPerPageArray"
                          :key="index"
                          @click="updateItemsPerPage(number)"
                        >
                          <v-list-item-title>{{ number }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-row>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <!-- <v-btn color="red" style="color:white;" class="pa-1 ml-1 mb-1" @click="addItem()">新增</v-btn> -->
                <v-switch v-model="switch1" label="Full Information" color="#239e46"></v-switch>
              </v-toolbar>
            </template>
            <template v-slot:item.plate="{ item }">
              {{item.plate}}
              <v-icon @click="dialog = !dialog;memberItem = item;">mdi-card-account-details</v-icon>
            </template>

            <template v-slot:footer>
              <div class="text-center pa-2 ma-2">
                <v-pagination
                  color="red"
                  v-model="currentPage"
                  :length="maxPage"
                  :total-visible="9"
                  @input="getInterpreterFromServer()"
                ></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-col>
        <v-col v-if="switch1">
          <gmap-map :center="items[0]" :zoom="12" style="width: 1100px; height: 600px">
            <gmap-marker
              v-for="(postion,index) in items"
              :key="index"
              :position="postion"
              :clickable="true"
              @click="center=postion"
              :label="{text:postion.plate,color:'#006030',fontSize:'18px'}"
              :icon="icon"
            ></gmap-marker>

            <!-- <gmap-polyline
              v-bind:path.sync="selectedArray"
              v-bind:options="{ strokeColor:'#008000'}"
            ></gmap-polyline>-->
          </gmap-map>
        </v-col>

        <v-col cols="5" v-if="!switch1">
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="pageSize"
            :loading="loading"
            :footer-props="{ itemsPerPageText:'Page Size' }"
            class="elevation-1"
            widths="500"
            no-data-text="No Data"
            loading-text="Processing"
            hide-default-footer
            multi-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <v-row class="pa-2 ma-2">
                    <span style="color:#239e46;">Total {{items.length}} , Page Size</span>

                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn dark text color="#239e46" class="ml-2" v-on="on">
                          {{ itemsPerPage }}
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(number, index) in itemsPerPageArray"
                          :key="index"
                          @click="updateItemsPerPage(number)"
                        >
                          <v-list-item-title>{{ number }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-row>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <!-- <v-btn color="red" style="color:white;" class="pa-1 ml-1 mb-1" @click="addItem()">新增</v-btn> -->
                <v-switch v-model="switch1" label="Full" color="#239e46"></v-switch>
              </v-toolbar>
            </template>
            <template v-slot:item.plate="{ item }">
              {{item.plate}}
              <v-icon @click="dialog = !dialog;memberItem = item;">mdi-card-account-details</v-icon>
            </template>

            <template v-slot:footer>
              <div class="text-center pa-2 ma-2">
                <v-pagination
                  color="red"
                  v-model="currentPage"
                  :length="maxPage"
                  :total-visible="9"
                  @input="getInterpreterFromServer()"
                ></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="7" v-if="!switch1">
          <gmap-map :center="items[0]" :zoom="12" style="width: 600px; height: 600px">
            <gmap-marker
              v-for="(postion,index) in items"
              :key="index"
              :position="postion"
              :clickable="true"
              @click="center=postion"
              :label="{text:postion.plate,color:'#006030',fontSize:'18px'}"
              :icon="icon"
            ></gmap-marker>

            <!-- <gmap-polyline
              v-bind:path.sync="selectedArray"
              v-bind:options="{ strokeColor:'#008000'}"
            ></gmap-polyline>-->
          </gmap-map>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" width="1000px" v-if="dialog">
      <BusDetail :memberItem="memberItem" v-on:childDialog="parentDialog"></BusDetail>
    </v-dialog>
  </v-form>
</template>
<script>
import BusDetail from "../components/Common/BusDetail";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    BusDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  data() {
    return {
      dialog: false,
      switch1: true,
      valid: false,
      loading: false,
      options: {},

      items: this.getFakeModel("bus"),
      queryObject: {},
      queryPager: {
        pageSize: 5,
        currentPage: 1,
        sortColumnNameList: []
      },
      itemsPerPageArray: [5, 10, 30, 50],
      currentPage: 1,
      itemsPerPage: 5,
      maxPage: 0,
      pageSize: 10,
      totalCount: 0,
      criterion: {},
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),
      headers: [
        // { text: "培訓單位", value: "mainDeptName", width: 100 },
        // { text: "帳號", value: "account", width: 100 },
        // { text: "姓名", value: "name", width: 100 },
        // { text: "性別", value: "gender", width: 100 },
        // { text: "統一證號或身分證字號", value: "idNo", width: 100 },
        // { text: "原屬國籍", value: "nationality", width: 100 },
        // { text: "行動電話", value: "contactMobileTel", width: 100 },
        // { text: "動作", value: "action", width: 90, sortable: false }
        { text: "License Plate", value: "plate", width: 100 },
        { text: "Driver Name", value: "name", width: 60 },
        { text: "Type", value: "type", width: 50 },
        { text: "Speed", value: "speed", width: 50 },
        { text: "Nexp Stop", value: "nextStop", width: 100 },
        { text: "Destination", value: "destination", width: 100 },
        { text: "Class Of Car", value: "classOfCar", width: 50 },
        { text: "Commercial", value: "commercialDescription", width: 100 },
        { text: "Make", value: "makeAndType", width: 50 },
        { text: "Capacity", value: "passengerCap", width: 50 },
        { text: "Year", value: "yearOfCar", width: 50 }
      ],
      icon: {
        labelOrigin: { x: 8, y: -4 },
        url:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAM5JREFUSMftlTEKwjAUhj+lnWxHJ72BR3H0Hj2AjnoZ0dkL6A30CN1El+KkUJcXkLRpX1JQhH4QQpI/70/SJg/+nYGjPwYWwByYAWNgBKQyXgAP4ApcgAOwB14a06lMKj3LGZhoDHYBwU3ZagzuHQxuGgMj9qV23jAgkBe9QStRw1jIh/7+Dn5qsAQSYNVRU8FcmETaKe6bW6dp3UEudSYBsobF2JocBRvC36K1HawuH0TA0+dMP4ixcoIr4ZQKjUrr+otOUh8Vq/bR9lR5A49NXsOJN+ZIAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTA0LTE4VDAzOjM5OjU2KzAwOjAw4kwlRwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0wNC0xOFQwMzozOTo1NiswMDowMJMRnfsAAAAodEVYdHN2ZzpiYXNlLXVyaQBmaWxlOi8vL3RtcC9tYWdpY2stcXFUSld0dHJ2lhxiAAAAAElFTkSuQmCC"
      }
    };
  },
  watch: {
    options: {
      handler() {
        this.getInterpreterFromServer();
      },
      deep: true
    },
    switch1(val) {
      var vm = this;
      console.log("val " + val);
      if (val) {
        vm.headers = [
          { text: "License Plate", value: "plate", width: 50 },
          { text: "Driver Name", value: "name", width: 60 },
          { text: "Type", value: "type", width: 50 },
          { text: "Speed", value: "speed", width: 50 },
          { text: "Nexp Stop", value: "nextStop", width: 100 },
          { text: "Destination", value: "destination", width: 100 },
          { text: "Class Of Car", value: "classOfCar", width: 50 },
          { text: "Commercial", value: "commercialDescription", width: 100 },
          { text: "Make", value: "makeAndType", width: 50 },
          { text: "Capacity", value: "passengerCap", width: 50 },
          { text: "Year", value: "yearOfCar", width: 50 }
        ];
      } else {
        vm.headers = [
          { text: "License Plate", value: "plate", width: 80 },
          { text: "Driver Name", value: "name", width: 50 },

          { text: "Speed", value: "speed", width: 30 },
          { text: "Nexp Stop", value: "nextStop", width: 50 },
          { text: "Destination", value: "destination", width: 50 }
        ];
      }
    }
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    getColor(value) {
      if (value == "AAA") {
        return "需求單位";
      } else if (value == "BBB") {
        return "培訓單位";
      } else if (value == "CCC") {
        return "通譯人員";
      } else if (value == "Y") {
        return "啟用";
      } else if (value == "N") {
        return "停用";
      } else if (value == "W") {
        return "待審核";
      } else if (value == "F") {
        return "女";
      } else if (value == "M") {
        return "男";
      } else {
        return value;
      }
    },
    addItem() {
      this.$router.push({
        path: "/ListInterpreterEdit/init"
      });
    },
    editItem(item) {
      this.$router.push({
        path: "/ListInterpreterEdit/" + item.uuid
      });
    },
    deleteItem(item) {
      if (confirm("確定要刪除帳號" + item.account + "嗎?")) {
        console.log("delete Item " + item.uuid);
        var vm = this;
        vm.axios
          .delete(vm.idbServerUrl + "idb/member/memberAccount/" + item.uuid, {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          })
          .then(function(response) {
            console.log("response " + JSON.stringify(response));
            vm.delSuccessSwalUtil();
            vm.getInterpreterFromServer();
          })
          .catch(function(error) {
            vm.handErrorUtil(error.response.status);
            //console.log("!!!! " + error);
          });
      } else {
        console.log("delete canceled" + item.uuid);
      }
    },

    updateItemsPerPage(number) {
      this.itemsPerPage = number;
      this.getInterpreterFromServer();
    },

    getInterpreterFromServer() {
      var vm = this;

      //   const { sortBy, sortDesc } = this.options;

      //   var sortColumnNameList = ["-lastModifyDate"];
      //   sortBy.forEach((element, index) => {
      //     sortColumnNameList[index] = (sortDesc[index] ? "-" : "") + element;
      //   });

      //   var queryObjectStr = JSON.stringify(vm.queryObject);

      //   var queryPagerStr = JSON.stringify({
      //     pageSize: vm.itemsPerPage,
      //     currentPage: vm.currentPage,
      //     sortColumnNameList: sortColumnNameList
      //   });
      //   var criterionStr = JSON.stringify({
      //     equal: [
      //       { propertyName: "type", value: "CCC" },
      //       {
      //         propertyName: "mainDeptId",
      //         value: vm.userProfile.memberAccount.mainDeptId
      //       }
      //     ]
      //   });

      //   if (
      //     vm.userProfile.memberAccount.type == "AAA" &&
      //     vm.userProfile.sysAdmin
      //   ) {
      //     criterionStr = JSON.stringify({
      //       equal: [{ propertyName: "type", value: "CCC" }]
      //     });
      //   }
      //   vm.axios
      //     .get(
      //       vm.idbServerUrl +
      //         "idb/member/memberAccount?queryString=" +
      //         encodeURIComponent(queryObjectStr) +
      //         "&queryPager=" +
      //         encodeURIComponent(queryPagerStr) +
      //         "&criterion=" +
      //         encodeURIComponent(criterionStr),
      //       {
      //         headers: {
      //           "Content-Type": "application/json",
      //           Authorization: vm.$localStorage.get("idb_login_token")
      //         }
      //       }
      //     )
      //     .then(function(response) {
      //       //var dataResponse = JSON.stringify(response.data.resultList)
      //       console.log("Result \n" + JSON.stringify(response.data.resultList));
      //       vm.currentPage = response.data.currentPage;
      //       vm.maxPage = response.data.maxPage;
      //       vm.pageSize = response.data.pageSize;
      //       vm.totalCount = response.data.totalCount;
      //       vm.items = response.data.resultList;

      //       for (var i = 0; i < vm.items.length; i++) {
      //         if (vm.items[i].creatorName === "user") {
      //           vm.items[i].mainDeptName = "個人申請";
      //         }
      //       }
      //     })
      //     .catch(function(error) {
      //       vm.handErrorUtil(error);
      //       //console.log(error);
      //     });
    },
    test(item) {
      console.log("item " + JSON.stringify(item));
    }
  },
  mounted() {
    var vm = this;
    vm.getInterpreterFromServer();
  }
};
</script>




